var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNoresponde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2728 20.5669C32.1901 20.556 32.108 20.5493 32.0273 20.5479C32.0273 20.5479 31.9893 20.3899 31.9181 20.1179C32.1894 18.172 32.2504 15.7777 31.8055 13.6283C31.8055 13.6283 33.044 9.76356 30.257 6.18439C28.0391 3.3357 25.0982 4.09738 25.0982 4.09738L25.3946 4.54029C24.1819 3.15257 21.5156 1.26836 16.3649 2.29389C16.3649 2.29389 11.5133 3.16817 10.1975 2.05378L11.3804 4.47042C11.3804 4.47042 7.78561 5.08222 5 3.71281C5.91294 6.95557 7.46208 9.282 9.30288 10.8712C7.38069 15.0364 8.44692 19.6166 8.44692 19.6166C8.44692 19.8608 8.47066 20.2176 8.50999 20.6435L8.49779 20.5513C8.35264 20.5418 8.2041 20.5465 8.0542 20.5669C6.82859 20.7303 5.96788 21.8563 6.13134 23.0819L6.48403 25.7251C6.64749 26.9507 7.7734 27.8114 8.99902 27.6479C9.13874 27.6296 9.27304 27.5984 9.40191 27.5557V27.5509C9.63048 29.2262 10.2043 32.6107 11.2013 33.5135C11.2013 33.5135 15.6059 37.9995 20.2934 37.9995C24.9809 37.9995 28.927 33.7075 28.927 33.7075C30.0773 32.7261 30.685 29.0594 30.8912 27.5441C31.0303 27.5923 31.1761 27.6269 31.3273 27.6472C32.553 27.8107 33.6789 26.95 33.8423 25.7244L34.195 23.0812C34.3585 21.8556 33.4978 20.7297 32.2722 20.5662L32.2728 20.5669Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2506 6.91486C29.488 5.95689 28.6368 5.43396 27.858 5.15688C26.8114 4.78491 25.8964 4.89191 25.2973 4.95497C25.2569 4.95943 25.2172 4.96325 25.1781 4.96771C24.9411 4.75179 24.6936 4.54605 24.4579 4.37471C23.5943 3.74605 21.3456 2.44476 16.912 3.26133C16.912 3.26133 12.2538 4.08236 10.9904 3.03585L12.1261 5.30529C12.1261 5.30529 8.67461 5.88046 6 4.59446C9.30891 16.0952 21.3352 15.3213 24.2573 11.3499C24.2573 11.3499 25.1052 14.4646 31.7367 13.9054C31.7367 13.9054 32.9258 10.276 30.2499 6.91486H30.2506Z",
    fill: "#F5FBFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5638 13.8023C32.0289 16.0496 31.926 18.572 31.6113 20.5317C31.389 21.9143 30.9128 25.5824 30.7551 26.6932C30.7551 26.6932 30.1865 32.1186 28.7651 33.3309C28.7651 33.3309 24.9267 37.505 20.3688 37.505C15.8108 37.505 11.5266 33.1423 11.5266 33.1423C10.2232 31.9622 9.66251 26.4175 9.66251 26.4175C9.53059 25.4861 8.84722 20.9222 8.84722 19.6274C8.84722 19.6274 7.81096 15.173 9.67966 11.1223",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1654 6.21361C26.1654 6.21361 24.1067 1.2757 16.5481 2.77963C16.5481 2.77963 11.8299 3.62988 10.5502 2.54613L11.7006 4.89635C11.7006 4.89635 8.20526 5.49198 5.49554 4.16087",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0411 4.53347C25.0411 4.53347 27.9012 3.79272 30.0582 6.56312C32.7679 10.0439 31.5641 13.8024 31.5641 13.8024C24.8472 14.3816 23.9883 11.156 23.9883 11.156",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49573 4.16003C8.84725 16.0701 21.0284 15.2687 23.9881 11.1559",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2217 12.2422C9.50938 15.6076 8.84778 19.6273 8.84778 19.6273",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2069 13.8716C30.7148 16.0701 31.7794 20.5318 31.7794 20.5318C31.8586 20.5337 31.9384 20.5397 32.0182 20.5502C33.2101 20.7092 34.0472 21.8042 33.8882 22.9961L33.5452 25.5666C33.3863 26.7585 32.2913 27.5956 31.0994 27.4366C30.9523 27.4168 30.8104 27.3832 30.6752 27.3364",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0291 26.7306V22.9431C21.0291 21.9358 21.6703 21.0401 22.6241 20.7162L22.913 20.614C24.0996 20.2109 25.4004 20.3231 26.5 20.9246L27.184 21.2986",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7691 20.9365L17.8205 20.614C16.6339 20.2109 15.3331 20.3231 14.2335 20.9246L13.5495 21.2986",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77769 27.3481C9.65236 27.389 9.52109 27.4193 9.38587 27.4378C8.19394 27.5967 7.09897 26.7597 6.94001 25.5677L6.597 22.9972C6.43804 21.8053 7.27509 20.7103 8.46702 20.5514C8.6128 20.5322 8.75726 20.5276 8.89841 20.5362",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1094 22.4406L14.861 25.689",
    stroke: "#228C80",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0305 22.4406L22.782 25.689",
    stroke: "#228C80",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1094 25.6887L14.861 22.4402",
    stroke: "#228C80",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0305 25.6887L22.782 22.4402",
    stroke: "#228C80",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0259 30.4828H25.214",
    stroke: "#228C80",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5388 33.2393C22.5537 33.2393 23.3764 32.0052 23.3764 30.4828H19.7012C19.7012 32.0052 20.5239 33.2393 21.5388 33.2393Z",
    fill: "#F9839A",
    stroke: "#228C80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoresponde);
export default __webpack_public_path__ + "static/media/Ic_no responde.0c8e29c661d35ee24c7e04aaba3063e9.svg";
export { ForwardRef as ReactComponent };